exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-content {\n  width: 5.6rem;\n  height: 5.6rem;\n  background-color: #007DE3;\n  border-radius: 3.2rem;\n  -webkit-box-shadow: 0px 3.2px 7.2px rgba(0, 0, 0, 0.12);\n          box-shadow: 0px 3.2px 7.2px rgba(0, 0, 0, 0.12);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: fixed;\n  z-index: 5000;\n  bottom: 0.8rem;\n  right: 0.8rem;\n  -webkit-transition: 0.4s all ease-in;\n  transition: 0.4s all ease-in;\n}", ""]);

// exports
